export default "__VITE_ASSET__dNn7wnUi__"